import script from "./studySingleCellPage.vue?vue&type=script&setup=true&lang=js"
export * from "./studySingleCellPage.vue?vue&type=script&setup=true&lang=js"

import "./studySingleCellPage.vue?vue&type=style&index=0&id=2fb291a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fb291a0"]])

export default __exports__